<ng-container>
  <div class="section-title">
    <div>{{ 'LISTING_SYNC.COLUMN_HEADERS.CONNECTED_ACCOUNT' | translate }}</div>
  </div>
  @if (!additionalAccounts?.length && account?.username) {
    <div class="connected-account">
      <local-seo-source-name-icon
        *ngIf="account?.profileImageUrl"
        [iconUrl]="account?.profileImageUrl"
        [defaulticonUrl]="defaultIconUrl"
        [iconSize]="24"
      ></local-seo-source-name-icon>
      <a *ngIf="account?.profileUrl" [href]="account?.profileUrl" target="_blank">
        {{ account?.username }}
      </a>
      <div *ngIf="!account?.profileUrl">
        {{ account?.username }}
      </div>
    </div>
  }

  @if (additionalAccounts?.length) {
    <mat-radio-group [(ngModel)]="selectedSSID" (change)="setSelectedSocialService()">
      <mat-radio-button [value]="account?.connectionId">
        <div class="connected-account">
          <local-seo-source-name-icon
            *ngIf="account?.profileImageUrl"
            [iconUrl]="account?.profileImageUrl"
            [defaulticonUrl]="defaultIconUrl"
            [iconSize]="24"
          ></local-seo-source-name-icon>
          <a *ngIf="listingUrl" [href]="listingUrl" target="_blank">
            {{ account?.username }}
          </a>
          <div *ngIf="!listingUrl">
            {{ account?.username }}
          </div>
        </div>
      </mat-radio-button>
      <mat-radio-button *ngFor="let service of additionalAccounts" [value]="service?.connectionId">
        <div class="connected-account">
          <local-seo-source-name-icon
            *ngIf="service?.profileImageUrl"
            [iconUrl]="service?.profileImageUrl"
            [defaulticonUrl]="defaultIconUrl"
            [iconSize]="24"
          ></local-seo-source-name-icon>
          <div>
            {{ service?.username }}
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  }
</ng-container>
